// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"753a7306","195":"c8e75be9","543":"212467df","660":"24425362"}[chunkId] + ".chunk.js";
};